/**
 * WaveInputFooter — the wave texture that renders BEHIND the landing-hero chat
 * input and pokes out below it with a matching 12px radius, so the box looks
 * like it's floating on the water.
 *
 * Rendered as the first child of the input's relative wrapper (before the
 * positioned input), so paint order puts it behind the opaque input; only the
 * portion below the box shows. Uses a real <img> (object-cover) rather than a
 * CSS background so the asset reliably loads.
 */

export function WaveInputFooter() {
  return (
    <div
      aria-hidden='true'
      className='pointer-events-none absolute inset-x-0 bottom-[-32px] h-[64px] overflow-hidden rounded-xl sm:bottom-[-40px] sm:h-[80px]'
    >
      <img
        src='/wave-input-footer.png'
        alt=''
        className='h-full w-full object-cover'
      />
    </div>
  );
}
